import React from 'react';

const Checkout = () => {
  return (
   <div id="App"></div>
  );
};

export default Checkout; 